import { ObjectRegistry } from '@lts-web/registry';

class TextBundleUtil {
    static #registry = new ObjectRegistry(String);

    /**
     * Get text
     * @param key
     * @returns {string}
     */
    static getText (key) {
        return TextBundleUtil.#registry.get(key);
    }

    /**
     * Add text
     * @param key
     * @param {string} text
     * @returns {boolean}
     */
    static addText (key, text) {
        return TextBundleUtil.#registry.set(key, text);
    }

    /**
     *
     * @param key
     * @returns {boolean}
     */
    static hasText (key) {
        return TextBundleUtil.#registry.has(key);
    }

    /**
     * Add Multiple Texts from Object
     * @param {object} textObject
     * @returns {*}
     */
    static addTexts (textObject) {
        return TextBundleUtil.#registry.merge(textObject);
    }
}

export default TextBundleUtil;